import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="flex flex-col items-center justify-center min-h-[60vh] text-center">
      <div className="text-[120px] font-black text-gradient-green leading-none mb-4">404</div>
      <h1 className="text-2xl font-black text-white mb-2">Page Not Found</h1>
      <p className="text-zinc-500 text-sm mb-8 max-w-sm">Looks like this stage is empty. The page you're looking for doesn't exist or has been moved.</p>
      <Link to="/" className="bg-[#00ff77] text-black font-bold px-6 py-2.5 rounded-full hover:bg-[#00e66b] transition-colors">
        Back to Feed
      </Link>
    </div>
  );
}
